export default "__VITE_ASSET__56f88cc5__"